
import { Vue, Component } from 'vue-property-decorator'
import RevitElement from '@/types/revitElement'
import Column from '@/types/column'

@Component({})
export default class RevitElementSubElementsTab extends Vue {
  columns:Column[] = [
    {
      title: 'Referentie',
      key: 'reference',
      dataIndex: 'reference',
      filters: [],
      sorter: false,
      sortDirections: ['ascend', 'descend']
    },
    {
      title: 'Naam',
      key: 'name',
      dataIndex: 'name',
      filters: [],
      sorter: false,
      sortDirections: ['ascend', 'descend']
    }
  ]

  get currentItem () : RevitElement {
    return this.$store.getters.currentElement
  }
}
